'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagBbAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M0 1.85537e-08C9.33333 -7.23602e-05 18.6667 -9.06442e-05 28 1.9259e-06V20C18.6667 20 9.33333 20 0 20V1.85537e-08Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M0 1.85537e-08L28 1.9259e-06V20H0V1.85537e-08Z", fill: "#1132C7" }),
      /* @__PURE__ */ jsx("path", { d: "M18.6667 0L28 1.9259e-06V20L18.6667 20V0Z", fill: "#08379D" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 20L9.33333 20V-6.89559e-06L0 1.85537e-08V20Z",
          fill: "#08379D"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.33333 20L18.6667 20V0L9.33333 -6.89559e-06V20Z",
          fill: "#FFCC50"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M13.7456 6.41349C13.8794 6.21679 14.1702 6.21949 14.3003 6.41864L14.9965 7.48436C15.1413 7.70607 14.9822 7.99999 14.7174 7.99999H14.7017C14.5045 7.99999 14.3504 8.17027 14.37 8.3665L14.6367 11.0332C14.6537 11.2036 14.7971 11.3333 14.9683 11.3333H15.1963C15.2841 11.3333 15.3683 11.2987 15.4307 11.237L15.9011 10.7717C15.9644 10.7091 16 10.6237 16 10.5347V9.4714C16 9.38299 15.9649 9.29821 15.9024 9.2357L15.7147 9.04804C15.5395 8.87282 15.6099 8.57446 15.845 8.49611L16.798 8.17843C17.0387 8.09822 17.2771 8.30548 17.2313 8.55495L16.7397 11.2277C16.7271 11.2964 16.6932 11.3594 16.6429 11.4077L15.4301 12.5736C15.368 12.6333 15.2852 12.6667 15.1991 12.6667H15C14.8159 12.6667 14.6667 12.8159 14.6667 13V13.6667C14.6667 13.8508 14.5174 14 14.3333 14H13.6667C13.4826 14 13.3333 13.8508 13.3333 13.6667V13C13.3333 12.8159 13.1841 12.6667 13 12.6667H12.8047C12.7163 12.6667 12.6315 12.6315 12.569 12.569L11.4047 11.4047C11.3582 11.3582 11.3264 11.2989 11.3135 11.2344L10.7793 8.56323C10.7291 8.31226 10.9688 8.1007 11.2116 8.18163L12.155 8.49611C12.3901 8.57446 12.4605 8.87282 12.2853 9.04804L12.0976 9.2357C12.0351 9.29821 12 9.38299 12 9.4714V10.5347C12 10.6237 12.0356 10.7091 12.0989 10.7717L12.5693 11.237C12.6317 11.2987 12.7159 11.3333 12.8037 11.3333H13.0317C13.2029 11.3333 13.3463 11.2036 13.3633 11.0332L13.63 8.3665C13.6496 8.17027 13.4949 7.99999 13.2976 7.99999C13.03 7.99999 12.8703 7.70051 13.0208 7.47921L13.7456 6.41349Z",
          fill: "#262626"
        }
      )
    ]
  }
);
const VpFlagBbAsset = forwardRef(FlagBbAsset);

export { VpFlagBbAsset as default };
